import _ from "lodash";
import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {activeCompanyIdAtom} from "./activeCompanyStore";
import {Order} from "../types/domain/order";
import {getOrdersByCompany} from "../services/orderService";

export interface OrdersStruct {
    orders: Order[];
    mapByOrderId: _.Dictionary<Order>;
}

export const activeCompanyOrdersAtom = atomWithRefresh<Promise<OrdersStruct>>(async (get) => {
    const activeCompanyId = await get(activeCompanyIdAtom);
    let allOrders: Order[] = [];
    if (activeCompanyId) {
        allOrders = await getOrdersByCompany(activeCompanyId);
    }
    return {
        orders: allOrders,
        mapByOrderId: _.keyBy(allOrders, "id"),
    };
});

export const activeCompanyOrdersLoadable = loadable(activeCompanyOrdersAtom);
